import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { LocaleService } from '../../shared/services/locale.service';

@Injectable({ providedIn: 'root' })
export class LanguageRedirectGuard implements CanActivate {
	constructor(private router: Router, private locale: LocaleService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		// If never opened in the current browser this will trigger the pop up to select language which is mandatory
		let loc_lang = localStorage.getItem('lang');
		if (!loc_lang) return true;

		const lang = route['lang'];
		// Get the current language from your language service or any other means
		let currentURL = state.url;
		if (currentURL === '/') currentURL = ''; //For home page
		if (!lang) {
			// Modify the URL to prepend the current language
			const modifiedUrl = `/${loc_lang}${currentURL}`;

			// Redirect to the modified URL
			this.router.navigateByUrl(modifiedUrl);
			return false;
		}
		return true;
	}
}
